module.exports = __webpack_public_path__ + "img/seat_selected2.bb890501.png";